import * as React from 'react'

const SvgProPlusIcon = (props) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.33398" y="2" width="32" height="32" rx="16" fill="#FFF4ED" />
    <g clipPath="url(#clip0_3049_80335)">
      <path
        d="M18.3346 21.3333C15.9414 21.3333 14.0013 19.3932 14.0013 17V13.037C14.0013 12.6916 14.0013 12.5189 14.0638 12.3849C14.13 12.2429 14.2442 12.1287 14.3862 12.0625C14.5202 12 14.6929 12 15.0383 12H21.6309C21.9764 12 22.1491 12 22.283 12.0625C22.4251 12.1287 22.5393 12.2429 22.6055 12.3849C22.668 12.5189 22.668 12.6916 22.668 13.037V17C22.668 19.3932 20.7279 21.3333 18.3346 21.3333ZM18.3346 21.3333V24M21.668 24H15.0013M25.0013 13.3333V16.6667M11.668 13.3333V16.6667"
        stroke="#FF692E"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect
      x="2.33398"
      y="2"
      width="32"
      height="32"
      rx="16"
      stroke="#FFE6D5"
      strokeWidth="4"
    />
    <defs>
      <clipPath id="clip0_3049_80335">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(10.334 10)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgProPlusIcon
